import Modal from "react-bootstrap/Modal";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear, faHouse, faQuestionCircle, faXmark } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Switch from "../../../components/ui/Switch";
import { ChromePicker, CirclePicker } from 'react-color';
import BoardModalArchive from "./BoardModalArchive";
import axios from "axios";
import CardName from "../../../components/global/CardName";
import ButtonAction from "../../../components/global/ButtonAction";
import TabBarCard from "../../../components/ui/TabBarCard";
import CardDescription from "../../../components/card/CardDescription";
import gammaPng from '../../../files/system/Color_Gamma.png';
import ProjectForUserObjectList from "../../../util/ProjectForUserObjectList";
import CardProject from "../../../components/card/projectMultiple/CardProject";
import useOutsideClick from "../../../util/useOutsideClick";
import ErrorAdd from "../../../util/ErrorAdd";

function BoardModal({ show, onHide, model, projectSelected }) {

    const idObject = 3;//Доски
    //TAB START
    const tab = [
        { id_tab: 0, name: "Основное", icon: faHouse, showCount: false }
        , { id_tab: 1, name: "Расширенные настройки", icon: faGear, showCount: false }
    ];
    const [tabSelected, setTabSelected] = useState(0);

    function tabHandler(id_tab) {
        setTabSelected(id_tab);
    }
    //TAB END

    const stateBoardList = useSelector((state) => state.boardList);
    const stateBoardProjectList = useSelector((state) => state.boardProjectList);
    const stateProject = useSelector((state) => state.projectList);
    const stateData = useSelector((state) => state.data);
    const stateUserList = useSelector((state) => state.userList);
    const stateSetting = useSelector((state) => state.setting);//Настройки

    const [archiveModalShow, setArchiveModalShow] = useState(false);

    const [colorShow, setColorShow] = useState(false);

    const [log, setLog] = useState(null);

    const [switchAvailableAllUser, setSwitchAvailableAllUser] = useState(true);
    const [switchAvailableAllTransfer, setSwitchAvailableAllTransfer] = useState(true);

    const [transferAvailableList, setTransferAvailableList] = useState([]);
    const [responsibleAvailableList, setResponsibleAvailableList] = useState([]);
    const [formProjectSelect, setFormProjectSelect] = useState([]);//Список выбранных проектов
    const [formProjectAvailable, setFormProjectAvailable] = useState([]);//Список доступных проектов для выбора


    useEffect(() => {

        setFormColor(model.Color === null ? '#dddfe0' : model.Color);

        //START ПРОЕКТЫ
        //Загружаем выбранные проекты указанной доски
        axios.get('/api_tracker/board/projectListByBoard', { params: { ID_Board: model.ID } })
            .then((res) => {
                setFormProjectSelect(res.data.Data.map(item => {
                    return { ID_Project: item.ID_Project }
                }));
            })
            .catch((err) => {
                ErrorAdd(err, window.location.href);
            });
        //Загружаем проекты доступные для пользователя
        if (stateProject.listLoaded.filter(a => a.id_status === 1).length > 0
            & stateProject.listObjectLoaded.filter(a => a.id_status === 1).length > 0
            & stateProject.listUserLoaded.filter(a => a.id_status === 1).length > 0
            & idObject != null & stateSetting.user != null & stateSetting.companyService != null) {

            const projects = ProjectForUserObjectList(stateProject.list, stateProject.listObject, stateProject.listUser, idObject, stateSetting.user.ID, stateSetting.companyService.ID_Role).map(item => {
                return { value: item.ID, label: item.Name }
            })

            setFormProjectAvailable(projects);
        }
        //END ПРОЕКТЫ     

        if (stateBoardProjectList.list.filter(a => a.ID_Board === model.ID & a.ID_Project === projectSelected).length > 0) {
            setSwitchAvailableAllUser(stateBoardProjectList.list.filter(a => a.ID_Board === model.ID & a.ID_Project === projectSelected)[0].All_User);
            setSwitchAvailableAllTransfer(stateBoardProjectList.list.filter(a => a.ID_Board === model.ID & a.ID_Project === projectSelected)[0].All_Transfer);
        }

        //if (stateProject.list.length > 0) {
        setResponsibleAvailableList(availableResponsibleGenerate(stateBoardProjectList.listUser.filter(a => a.ID_Project === projectSelected & a.ID_Board === model.ID)));
        setTransferAvailableList(availableTransferGenerate(stateBoardProjectList.listTransfer.filter(a => a.ID_Project === projectSelected & a.ID_Board === model.ID)));

        // }

    }, [model, stateBoardProjectList, stateBoardList]);

    /************************************START ПЕРЕМЕЩЕНИЯ***************************************/
    //Сгенерирует доступные доски
    function availableTransferGenerate(boardsSelected) {
        const boards = stateBoardProjectList.list.filter(a => a.ID_Project === projectSelected & a.ID_Board !== model.ID).map(board => {
            return { ID_Board: board.ID_Board, Name: stateBoardList.list.filter(a => a.ID === board.ID_Board) > 0 && stateBoardList.list.filter(a => a.ID === board.ID_Board)[0].Name, Added: boardsSelected.filter(a => a.ID_Board_Available === board.ID_Board).length > 0 ? true : false }
        })
        return boards;
    }
    function availableTransferHandler(checked, id) {
        setTransferAvailableList(transferAvailableList.map(item => {
            if (id === item.ID_Board) {
                return { ...item, Added: checked };
            }
            else {
                return item;
            }
        }))

        axios.post('/api_tracker/board/projectTransferAvailableSet',
            {
                ID_Board: model.ID, ID_Board_Available: id, ID_Project: projectSelected, Add: checked
            })
            .then((res) => {
                if (res.data.Status === 1) {

                }
                else {
                    setLog(res.data.Error);
                    //setLoading(false);
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                ErrorAdd(err, window.location.href);
            });
    }
    function availableTransferAllHandler(checked) {
        setSwitchAvailableAllTransfer(checked)

        if (checked === false) {
            setTransferAvailableList(availableTransferGenerate([]));
        }
        else {
            setTransferAvailableList({});
        }

        axios.post('/api_tracker/board/projectUpdateAllTransfer',
            {
                ID_Board: model.ID, ID_Project: projectSelected, All_Transfer: checked
            })
            .then((res) => {
                if (res.data.Status === 1) {

                }
                else {
                    setLog(res.data.Error);
                    //setLoading(false);
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                ErrorAdd(err, window.location.href);
            });
    }
    /*************************************END ПЕРЕМЕЩЕНИЯ****************************************/
    /***********************************START ОТВЕТСТВЕННЫЕ**************************************/



    //Сгенерирует доступных пользователей
    function availableResponsibleGenerate(usersSelected) {
        //Настройка проекта "ДОСТУПНЫЕ ПОЛЬЗОВАТЕЛИ"

        //console.log('projectSelected', projectSelected)
        //console.log('stateProject.list', stateProject.list)
        //console.log('stateProject.list.filter(a => a.ID === projectSelected)', stateProject.list.filter(a => a.ID === projectSelected))
        const all_user = stateProject.list.filter(a => a.ID === projectSelected)[0].All_User;

        if (all_user === true) {
            const users = stateUserList.list.map(user => {
                return { ID_User: user.ID_User, Name_User: user.Name_User, Added: usersSelected.filter(a => a.ID_User === user.ID_User).length > 0 ? true : false }
            })

            return users
        }
        else {
            var users = [];
            //Админы
            stateUserList.list.filter(a => a.ID_Role === 0 || a.ID_Role === 1).map(user => {
                users.push({ ID_User: user.ID_User, Name_User: user.Name_User, Added: usersSelected.filter(a => a.ID_User === user.ID_User).length > 0 ? true : false })
            })
            //Пользователи
            stateProject.listUser.filter(a => a.ID_Project === projectSelected).map(user => {
                if (users.filter(a => a.ID_User === user.ID_User).length === 0) {
                    users.push({ ID_User: user.ID_User, Name_User: stateUserList.list.filter(a => a.ID_User === user.ID_User)[0].Name_User, Added: usersSelected.filter(a => a.ID_User === user.ID_User).length > 0 ? true : false })
                }
            })

            return users
        }
    }
    //Доска доступна для всех
    function availableResponsibleAllHandler(checked) {
        setSwitchAvailableAllUser(checked);

        if (checked === false) {
            setResponsibleAvailableList(availableResponsibleGenerate([]));
        }
        else {
            setResponsibleAvailableList([]);
        }

        axios.post('/api_tracker/board/projectUpdateAllUser',
            {
                ID_Board: model.ID, ID_Project: projectSelected, All_User: checked
            })
            .then((res) => {
                if (res.data.Status === 1) {

                }
                else {
                    setLog(res.data.Error);
                    //setLoading(false);
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                ErrorAdd(err, window.location.href);
            });
    }
    //Выбор пользователя
    function availableResponsibleHandler(checked, id) {

        setResponsibleAvailableList(responsibleAvailableList.map(item => {
            if (id === item.ID_User) {
                return { ...item, Added: checked };
            }
            else {
                return item;
            }
        }))

        axios.post('/api_tracker/board/projectUserAvailableSet',
            {
                ID_Board: model.ID, ID_Project: projectSelected, ID_User: id, Add: checked
            })
            .then((res) => {
                if (res.data.Status === 1) {

                }
                else {
                    setLog(res.data.Error);
                    //setLoading(false);
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                ErrorAdd(err, window.location.href);
            });
    }
    /************************************END ОТВЕТСТВЕННЫЕ***************************************/

    const [logProject, setLogProject] = useState(null);
    const [loadingProject, setLoadingProject] = useState(false);

    function updateProject(idProject, added) {
        setLoadingProject(true);
        setLogProject(null);

        axios.post('/api_tracker/board/projectSet', { ID_Board: model.ID, ID_Project: idProject, Added: added })
            .then((resResp) => {
                if (resResp.data.Status !== 1) {
                    setLogProject(resResp.data.Error);
                    setLoadingProject(false);
                }
                else {
                    setLoadingProject(false);
                }
            })
            .catch((err) => {
                setLogProject('Неизвестная ошибка!');
                setLoadingProject(false);
                ErrorAdd(err, window.location.href);
            });
    }

    const [logColor, setLogColor] = useState(null);
    const [loadingColor, setLoadingColor] = useState(false);
    const colorOutsideClick = useOutsideClick((e) => {
        updateColor(formColor);
        setColorShow(false);
    });

    const [formColor, setFormColor] = useState(undefined);
    function updateColor(val) {
        setLoadingColor(true);
        setLogColor(null);

        axios.post('/api_tracker/board/updateColor', { ID_Board: model.ID, Color: val })
            .then((resResp) => {
                if (resResp.data.Status !== 1) {
                    setLogColor(resResp.data.Error);
                    setLoadingColor(false);

                    //setFormColor(val)
                }
                else {
                    setLoadingColor(false);
                }
            })
            .catch((err) => {
                setLogColor('Неизвестная ошибка!');
                setLoadingColor(false);
                ErrorAdd(err, window.location.href);
            });
    }

    const [hideDescription, setHideDescription] = useState(false);
    const [logDescription, setLogDescription] = useState(null);
    const [loadingDescription, setLoadingDescription] = useState(false);

    function updateDescription(val) {
        setLoadingDescription(true);
        setLogDescription(null);

        axios.post('/api_tracker/board/updateDescription', { ID_Board: model.ID, Description: val })
            .then((resResp) => {
                if (resResp.data.Status !== 1) {
                    setLogDescription(resResp.data.Error);
                    setLoadingDescription(false);

                }
                else {
                    setLoadingDescription(false);
                    setHideDescription(true);
                }
            })
            .catch((err) => {
                setLogDescription('Неизвестная ошибка!');
                setLoadingDescription(false);
                ErrorAdd(err, window.location.href);
            });
    }

    const [hideName, setHideName] = useState(false);
    const [logName, setLogName] = useState(null);
    const [loadingName, setLoadingName] = useState(false);
    function updateName(val) {
        setLoadingName(true);
        setLogName(null);

        axios.post('/api_tracker/board/updateName', { ID_Board: model.ID, Name: val })
            .then((resResp) => {
                if (resResp.data.Status !== 1) {
                    setLogName(resResp.data.Error);
                    setLoadingName(false);

                }
                else {
                    setLoadingName(false);
                    setHideName(true);
                }
            })
            .catch((err) => {
                setLogName('Неизвестная ошибка!');
                setLoadingName(false);
                ErrorAdd(err, window.location.href);
            });
    }

    const [logTypeAppointment, setLogTypeAppointment] = useState(null);
    const [loadingTypeAppointment, setLoadingTypeAppointment] = useState(false);
    function updateTypeAppointment(val) {
        setLoadingTypeAppointment(true);
        setLogTypeAppointment(null);

        axios.post('/api_tracker/board/updateTypeAppointment', { ID_Board: model.ID, ID_Type_Appointment: val })
            .then((resResp) => {
                if (resResp.data.Status !== 1) {
                    setLogTypeAppointment(resResp.data.Error);
                    setLoadingTypeAppointment(false);
                }
                else {
                    setLoadingTypeAppointment(false);
                }
            })
            .catch((err) => {
                setLogTypeAppointment('Неизвестная ошибка!');
                setLoadingTypeAppointment(false);
                ErrorAdd(err, window.location.href);
            });
    }

    const [logTypeArchive, setLogTypeArchive] = useState(null);
    const [loadingTypeArchive, setLoadingTypeArchive] = useState(false);
    function updateTypeArchive(val) {
        setLoadingTypeArchive(true);
        setLogTypeArchive(null);
        setLogTypeArchiveVal(null);

        axios.post('/api_tracker/board/updateTypeArchive', { ID_Board: model.ID, ID_Type_Archive: val })
            .then((resResp) => {
                if (resResp.data.Status !== 1) {
                    setLogTypeArchive(resResp.data.Error);
                    setLoadingTypeArchive(false);
                }
                else {
                    setLoadingTypeArchive(false);
                }
            })
            .catch((err) => {
                setLogTypeArchive('Неизвестная ошибка!');
                setLoadingTypeArchive(false);
                ErrorAdd(err, window.location.href);
            });
    }

    const [logTypeArchiveVal, setLogTypeArchiveVal] = useState(null);
    const [loadingTypeArchiveVal, setLoadingTypeArchiveVal] = useState(false);
    function updateTypeArchiveVal(val) {
        setLoadingTypeArchiveVal(true);
        setLogTypeArchiveVal(null);

        axios.post('/api_tracker/board/updateTypeArchiveVal', { ID_Board: model.ID, ID_Type_Archive_Val: val })
            .then((resResp) => {
                if (resResp.data.Status !== 1) {
                    setLogTypeArchiveVal(resResp.data.Error);
                    setLoadingTypeArchiveVal(false);
                }
                else {
                    setLoadingTypeArchiveVal(false);
                }
            })
            .catch((err) => {
                setLogTypeArchiveVal('Неизвестная ошибка!');
                setLoadingTypeArchiveVal(false);
                ErrorAdd(err, window.location.href);
            });
    }

    const [logTypeDisplayTask, setLogTypeDisplayTask] = useState(null);
    const [loadingTypeDisplayTask, setLoadingTypeDisplayTask] = useState(false);
    function updateTypeDisplayTask(val) {
        setLoadingTypeDisplayTask(true);
        setLogTypeDisplayTask(null);
        //ID_Type_Display_Task

        axios.post('/api_tracker/board/updateTypeDisplayTask', { ID_Board: model.ID, ID_Type_Display_Task: val })
            .then((resResp) => {
                if (resResp.data.Status !== 1) {
                    setLogTypeDisplayTask(resResp.data.Error);
                    setLoadingTypeDisplayTask(false);
                }
                else {
                    setLoadingTypeDisplayTask(false);
                }
            })
            .catch((err) => {
                setLogTypeDisplayTask('Неизвестная ошибка!');
                setLoadingTypeDisplayTask(false);
                ErrorAdd(err, window.location.href);
            });
    }

    return (
        <>
            {archiveModalShow === true && (<BoardModalArchive show={archiveModalShow} onHide={() => setArchiveModalShow(false)} onHideBoard={onHide} idBoard={model.ID} />)}
            <Modal show={show} onHide={onHide} size="lg">
                <Modal.Body>
                    <div className="mb-5" style={{ display: 'flex' }}>
                        <div>
                            <TabBarCard tabData={tab} tabSelected={tabSelected} tabClikHandler={tabHandler} />
                        </div>
                        <div style={{ marginLeft: 'auto' }} className="modal_close" onClick={() => onHide()}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                    </div>
                    <div className="row" >
                        <div className="col-md-8">
                            <div className={tabSelected === 0 ? "d-block" : "d-none"} role="tabpanel">
                                <div className="mb-3">
                                    <CardName name={model.Name} onlyRead={false} updateHandler={updateName} placeholder='Название доски...' hide={hideName} setHide={setHideName} log={logName} loading={loadingName} />
                                    {model.ID_Type != null &&
                                        <div className="mt-0 text-uppercase fw-bold opacity-50"><FontAwesomeIcon className="mr-1" icon={stateData.boardType.filter(a => a.id === model.ID_Type)[0].icon} />  {stateData.boardType.filter(a => a.id === model.ID_Type)[0].name}</div>
                                    }
                                </div>
                                <div className="mb-3">
                                    <CardDescription text={model.Description} rows={5} placeholder="Описание..." updateHandler={updateDescription} loading={loadingDescription} log={logDescription} hide={hideDescription} setHide={setHideDescription} />
                                </div>
                                <div className="mb-3 mt-30_ mb-30_">
                                    <CardProject idItem={model.ID} idProject={projectSelected} idSelected={formProjectSelect} idObject={idObject} update={updateProject} loading={loadingProject} log={logProject} /*idObject={id_object} idSelected={formIdProject} update={updateProjectHandler} loading={loadingProject} log={logProject} hideModal={hideModalProject} onlyRead={formIdStatus === 2 ? true : false}*/ />
                                </div>
                                <div>Цвет</div>
                                <CirclePicker width="100%" color={formColor} colors={["#939393", "#dddfe0", "#ff756c", "#fe9f98", "#f29e40", "#ffc98c", "#ffffb6", "#edefb5", "#7fc59f", "#a7f7cc", "#6bcde9", "#b2eeff", "#9290ff", "#bcbafb"]} onChange={e => updateColor(e.hex)} />
                                <div className="mt-15 d-flex" style={{ cursor: 'pointer' }} onClick={() => { setColorShow(!colorShow) }}>
                                    <div className=" " style={{ backgroundColor: formColor, width: '100px', height: '30px', borderRadius: '5px' }} >

                                    </div>
                                    <img src={gammaPng} height={30} className="ml-5" />
                                    {loadingColor === true && <div className="loader_01"></div>}
                                </div>
                                {colorShow === true && (
                                    <div ref={colorOutsideClick} style={{ width: '225px', textAlign: 'center' }}>
                                        <ChromePicker className="mt-15 mb-5" color={formColor} onChange={e => setFormColor(e.hex)} disableAlpha={false} />
                                    </div>
                                )}
                            </div>
                            <div className={tabSelected === 1 ? "d-block" : "d-none"} role="tabpanel">
                                <div className="card-block-title">Основное</div>
                                <div className="setting_block_btn_header">
                                    <div className="title">Кто видит задачи</div>
                                    <div className="question">
                                        <OverlayTrigger
                                            placement="left-start"
                                            overlay={
                                                <Tooltip id='tooltip-top'>
                                                    <div>
                                                        <div><u>Все пользователи</u> - задачи будут видны всем пользователям проекта.</div>
                                                        <div><u>Только ответственные</u> - задачи увидят только ответственные, указанные в задаче</div>
                                                        <div className="mt-15 text-center"><i>Администраторы видят все задачи вне зависимости от выбора</i></div>
                                                    </div>
                                                </Tooltip>
                                            }
                                        >
                                            <FontAwesomeIcon icon={faQuestionCircle} className="mr-5" />
                                        </OverlayTrigger>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6 mt-10">
                                        <button className={'param_button' + (model.ID_Type_Display_Task === 1 ? ' active' : '')} onClick={() => updateTypeDisplayTask(1)} disabled={loadingTypeDisplayTask}>
                                            Все пользователи
                                        </button>
                                    </div>
                                    <div className="col-md-6 mt-10">
                                        <button className={'param_button' + (model.ID_Type_Display_Task === 2 ? ' active' : '')} onClick={() => updateTypeDisplayTask(2)} disabled={loadingTypeDisplayTask}>
                                            Только ответственные
                                        </button>
                                    </div>
                                </div>
                                {logTypeDisplayTask !== null && <div className="form_error text-center">{logTypeDisplayTask}</div>}

                                {model.ID_Type == 3 &&
                                    (
                                        <div className="mt-15">
                                            <div className="setting_block_btn_header">
                                                <div className="title">Способ архивирования</div>
                                                <div className="question">
                                                    <OverlayTrigger
                                                        placement="left-start"
                                                        overlay={
                                                            <Tooltip id='tooltip-top' >
                                                                <div>
                                                                    <div><u>Нажатием кнопки "В архив"</u> - Задача исчезнет с доски после нажатия пользователем кнопки "В архив"</div>
                                                                    <div><u>Через указанное кол-во дней</u> - Задача исчезнет с доски через заданное количество дней</div>
                                                                    <div><u>При достижении кол-ва задач</u> - Отображаются только указанное количество последних задач</div>
                                                                </div>
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <FontAwesomeIcon icon={faQuestionCircle} className="mr-5" />
                                                    </OverlayTrigger>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6 mt-10">
                                                    <button className={'param_button' + (model.ID_Type_Archive === 1 ? ' active' : '')} onClick={() => updateTypeArchive(1)} disabled={loadingTypeArchive}>
                                                        Нажатием кнопки "В архив"
                                                    </button>
                                                </div>
                                                <div className="col-md-6 mt-10">
                                                    <button className={'param_button' + (model.ID_Type_Archive === 2 ? ' active' : '')} onClick={() => updateTypeArchive(2)} disabled={loadingTypeArchive}>
                                                        Через указанное кол-во дней
                                                    </button>
                                                </div>
                                                <div className="col-md-6 mt-10">
                                                    <button className={'param_button' + (model.ID_Type_Archive === 3 ? ' active' : '')} onClick={() => updateTypeArchive(3)} disabled={loadingTypeArchive}>
                                                        При достижении кол-ва задач
                                                    </button>
                                                </div>
                                            </div>
                                            {logTypeArchive !== null && <div className="form_error text-center">{logTypeArchive}</div>}
                                            <div className="row">
                                                <div className="col-md-6">
                                                    {model.ID_Type_Archive == 2 && (

                                                        <Form.Group className="mb-3 mt-15" >
                                                            <Form.Label>Количество дней</Form.Label>
                                                            <Form.Control type="number" disabled={loadingTypeArchiveVal} onChange={(e) => { updateTypeArchiveVal(parseInt(e.target.value) < 1 ? 1 : parseInt(e.target.value)) }} value={model.ID_Type_Archive_Val} />
                                                        </Form.Group>

                                                    )}
                                                    {model.ID_Type_Archive == 3 && (
                                                        <Form.Group className="mb-3 mt-15" >
                                                            <Form.Label>Количество задач</Form.Label>
                                                            <Form.Control type="number" disabled={loadingTypeArchiveVal} onChange={(e) => updateTypeArchiveVal(parseInt(e.target.value) < 1 ? 1 : parseInt(e.target.value))} value={model.ID_Type_Archive_Val} />
                                                        </Form.Group>
                                                    )}
                                                    {logTypeArchiveVal !== null && <div className="form_error text-center">{logTypeArchiveVal}</div>}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }

                                <div className="card-block-title mt-25">Ответственные</div>

                                <div className="setting_block_btn_header">
                                    <div className="title">Способ назначения ответственных</div>
                                    <div className="question">
                                        <OverlayTrigger
                                            placement="left-start"
                                            overlay={
                                                <Tooltip id='tooltip-top'>
                                                    <div>
                                                        <div><u>Вручную</u> - Ответственный выбирается вручную на карточке задачи</div>
                                                        <div><u>Не требует ответственных</u> - Доска не требует назначения ответственных. Например: лист ожидания, TO DO, не разобранные задачи...</div>
                                                        <div><u>Выбор при перемещении</u> - При перемещении задачи на доску будет предложен выбор кого назначить.</div>
                                                        <div><u>Тот кто переместил</u> - Ответственным автоматически становится тот кто переместил задачу на доску.</div>
                                                        <div><u>Наследование</u> - Ответственный наследуется с предыдущей доски.</div>
                                                    </div>
                                                </Tooltip>
                                            }
                                        >
                                            <FontAwesomeIcon icon={faQuestionCircle} className="mr-5" />
                                        </OverlayTrigger>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6 mt-10">
                                        <button className={'param_button' + (model.ID_Type_Appointment === 1 ? ' active' : '')} onClick={() => updateTypeAppointment(1)} disabled={loadingTypeAppointment}>
                                            Вручную
                                        </button>
                                    </div>
                                    <div className="col-md-6 mt-10">
                                        <button className={'param_button' + (model.ID_Type_Appointment === 2 ? ' active' : '')} onClick={() => updateTypeAppointment(2)} disabled={loadingTypeAppointment}>
                                            Не требует ответственных
                                        </button>
                                    </div>
                                    <div className="col-md-6 mt-10">
                                        <button className={'param_button' + (model.ID_Type_Appointment === 3 ? ' active' : '')} onClick={() => updateTypeAppointment(3)} disabled={loadingTypeAppointment}>
                                            Выбор при перемещении
                                        </button>
                                    </div>
                                    <div className="col-md-6 mt-10">
                                        <button className={'param_button' + (model.ID_Type_Appointment === 4 ? ' active' : '')} onClick={() => updateTypeAppointment(4)} disabled={loadingTypeAppointment}>
                                            Тот кто переместил
                                        </button>
                                    </div>
                                    <div className="col-md-6 mt-10">
                                        <button className={'param_button' + (model.ID_Type_Appointment === 5 ? ' active' : '')} onClick={() => updateTypeAppointment(5)} disabled={loadingTypeAppointment}>
                                            Наследование
                                        </button>
                                    </div>
                                </div>
                                {logTypeAppointment !== null && <div className="form_error text-center">{logTypeAppointment}</div>}

                                <div className="mt-15">
                                    <Switch name="Доска доступна для всех" description="Опция позволяет ограничить список ответственных для доски" checked={switchAvailableAllUser} handleChange={availableResponsibleAllHandler} />
                                </div>
                                {switchAvailableAllUser === false && (
                                    <div className="mt-3">
                                        <u className="p-1">Список доступных ответственных:</u>
                                        {responsibleAvailableList.map((model, index) => (
                                            <Switch key={'resp_' + model.ID_User} id_item={model.ID_User} name={model.Name_User} checked={model.Added} handleChange={availableResponsibleHandler} />
                                        ))}
                                    </div>
                                )}
                                <small className="bg-warning"><i>* Настраивается для каждого проекта отдельно</i></small>

                                <div className="card-block-title mt-25">Перемещения</div>
                                <Switch name="Доступны все доски" description="Опция позволяет изменить доступ для перемещения задач с этой доски на другие доски. Выберите доски, на которые можно перемещать задачи" checked={switchAvailableAllTransfer} handleChange={availableTransferAllHandler} />
                                {switchAvailableAllTransfer === false && (
                                    <div className="mt-3">
                                        <u className="p-1">Список доступных досок:</u>
                                        {transferAvailableList.map((model, index) => (
                                            <Switch key={'transfer_' + model.ID_Board} id_item={model.ID_Board} name={model.Name} checked={model.Added} handleChange={availableTransferHandler} />
                                        ))}
                                    </div>
                                )}
                                <small className="bg-warning"><i>* Настраивается для каждого проекта отдельно</i></small>
                            </div>
                        </div>
                        <div className="col-md-4 text-center">
                            <div className="card-block-title">Действия</div>
                            <>
                                <div className="mt-10"><ButtonAction typeBtn='archive' onClick={() => setArchiveModalShow(true)} /></div>
                            </>
                            {log !== null && <div className="form_error text-center mt-15">{log}</div>}
                        </div>
                    </div>
                </Modal.Body>
            </Modal >
        </>
    );
}
export default BoardModal;
